"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Claim = function Claim() {
  return _react2.default.createElement(
    "g",
    { id: "claim" },
    _react2.default.createElement("path", {
      d: "M100,375 L100,325 L400,325 L400,375 L100,375 Z M100,275 L100,225 L400,225 L400,275 L100,275 Z M100,175 L100,125 L400,125 L400,175 L100,175 Z M475,0 L437.5,37.5 L400,0 L362.5,37.5 L325,0 L287.5,37.5 L250,0 L212.5,37.5 L175,0 L137.5,37.5 L100,0 L62.5,37.5 L25,0 L25,500 L25,500 L62.5,462.5 L100,500 L100.1,500 L137.6,462.5 L175,500 L175.1,500 L212.6,462.5 L250,500 L250.1,500 L287.6,462.5 L325,500 L325,500 L362.5,462.5 L400,500 L400,500 L437.5,462.5 L475,500 L475,500 L475,0 Z"
    })
  );
};

exports.default = Claim;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Claim.js
// module id = 2934
// module chunks = 4